import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import ReportIcon from '@material-ui/icons/Assessment';
import Avatar from '@material-ui/core/Avatar';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import LinearProgress from '@material-ui/core/LinearProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/styles';
import yellow from '@material-ui/core/colors/yellow';
import {withTranslation} from 'react-i18next';
import CardWithBackground from "../common/CardWithBackground";

const useStyles = makeStyles(theme => ({
    avatar: {
        backgroundColor: yellow[800],
    },
    link: {
        color: '#b24d43',
        textDecoration: 'none'
    },
}));

const DashboardRecentCampaigns = (props) => {
    const classes = useStyles();
    const {campaigns, campaignsLoading, t} = props;
    return (
        <CardWithBackground>
            <CardHeader title={t('Most recent campaigns')} avatar={
                <Avatar className={classes.avatar}>
                    <ReportIcon/>
                </Avatar>
            }/>
            <CardContent>
                {!campaignsLoading &&
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('Campaign')}</TableCell>
                            <TableCell>{t('Sent on')}</TableCell>
                            <TableCell>{t('Opened')}</TableCell>
                            <TableCell>{t('Report')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {campaigns.map(campaign => (
                            <TableRow hover key={campaign.id}>
                                <TableCell>
                                    <Typography>{campaign.name}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography noWrap>{campaign.createdAt.substr(0, 10)}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography>{campaign.report.ratioRead.toFixed(2)} %</Typography>
                                </TableCell>
                                <TableCell>
                                    <Link to={`/campaigns/${campaign.id}/report`} className={classes.link}>
                                        <ReportIcon/>
                                    </Link>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                }
                {campaignsLoading && <LinearProgress/>}
            </CardContent>
        </CardWithBackground>
    );
};

DashboardRecentCampaigns.propTypes = {
    campaigns: PropTypes.array.isRequired,
    campaignsLoading: PropTypes.bool.isRequired,
};

export default withTranslation()(DashboardRecentCampaigns);
